import { SVGAttributes, VFC } from "react";

const ChevronLeft: VFC<SVGAttributes<SVGElement>> = ({ ...rest }) => {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.29282 1.29297L2.58571 6.00008L7.29282 10.7072L8.70703 9.29297L5.41414 6.00008L8.70703 2.70718L7.29282 1.29297Z"
        fill="#191817"
      />
    </svg>
  );
};

export { ChevronLeft };
